/**
 * Exports the fonts used in the chat window. We are using this do we can declare specific
 * font faces to be used in the shadow DOM instead of trying to rely on consistent
 * definitions from the sites that we inject the chat into.
 */
export default class Fonts {
    static get FontCollection() {
        return `
            @font-face {font-family: 'HuntingtonChatMuliBook';
            src: url("https://www.huntington.com/Presentation/fonts/muli-v11-latin-300.woff2") format("woff2");
            font-weight: 300;}
        
            @font-face {font-family: 'HuntingtonChatMuliRegular';
            src: url("https://www.huntington.com/Presentation/fonts/muli-v11-latin-regular.woff2") format("woff2");
            font-weight: 400;}
        
            @font-face {font-family: 'HuntingtonChatMuliSemiBold';
            src: url("https://www.huntington.com/Presentation/fonts/muli-v11-latin-600.woff2") format("woff2");
            font-weight: 600;}
        
            @font-face {font-family: 'HuntingtonChatMuliBold';
            src: url("https://www.huntington.com/Presentation/fonts/muli-v11-latin-700.woff2") format("woff2");
            font-weight: 700;}
        `;
    }
}